import { styled } from '@mui/system'
import { FormControl } from '@mui/material'

export const StyleFormControl = styled(FormControl)(() => ({
  fontFamily: 'var(--gally-font)',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#151A47',
  flex: 'none',
  order: 0,
  flexGrow: 0,
  width: '100%',
}))
